import React,{ useState, useEffect } from 'react';
import './App.css';

import {
  BrowserRouter as Router, Switch, Route
} from "react-router-dom"

//Localhost
import { URL } from "./config"

//components
import Auth from "./components/Auth"
import Home from "./components/Home"
import Product from "./components/Product"
import Transactions from "./components/Transactions"
import Cart from "./components/Cart"

//layouts
import TopNav from "./components/layouts/Navbar"

//forms
import Register from "./components/forms/Register"
import Login from "./components/forms/Login"
import AddProduct from "./components/forms/AddProduct"
import UserTransaction from "./components/UserTransaction"


function App() {
  const [products, setProducts] = useState([])
  const [user, setUser] = useState({})
  const [token, setToken] = useState("")

  useEffect(()=>{
    fetch(`${URL}/products`)
    .then(res=>res.json())
    .then(data=>{
      setProducts(data)
    })
    setUser(JSON.parse(localStorage.getItem("user")))
    setToken(localStorage.getItem("token"))
  }, [])

  const logoutHandler = () => {
    localStorage.clear()
    setUser({})
    setToken("")
    window.location.href="/"
  }

  // console.log(token)

  return (
    <div className="App">
      <Router>

        <TopNav user={user} token={token} logoutHandler={logoutHandler} />

          <Switch>
            <Route path="/register">
              <Register />
            </Route>

            <Route path="/login">
              <Login />
            </Route>

            <Route path="/booking">
              { user && token  && user.isAdmin === false ? <Cart /> : <Auth /> }
            </Route>

            <Route path="/transactions/:userId">
              {user && token  && user.isAdmin === false ? <UserTransaction /> : <Auth /> }
            </Route> 
            
            <Route path="/transactions">
              {user && token && user.isAdmin ? <Transactions />  : <Auth /> }
            </Route>

            <Route path="/addtour">
              {user && token && user.isAdmin ? <AddProduct products={products} />  : <Auth /> }
            </Route> 

            <Route path="/tours/:id">
              <Product user={user} token={token} />
            </Route>
           
            <Route path="/">
              <Home products={products} user={user} token={token} />
            </Route>

          </Switch>
      </Router>
    </div>
    )
}

export default App;

